import {
  printReceiptQR, 
  printReceiptBT, 
  printReceiptSerial, 
  payInBT, 
  payInSerial, 
  payInQR,
  payOutBT,
  payOutSerial,
  payOutQR
} from './printCommands'
import {
  sam4sSale,
  sam4sPayIn,
  sam4sPayOut,
  sam4sPayOutMachine,
  sam4sPayInMachine,
  sam4sSaleMachine
} from './sam4sModel'

const sam4sDriver = {
  printReceipt: {
    Sam4sQR: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptQR(fiscalReceipt, printSlip, sam4sSale, deviceParams, sendMessageToWebView)
    },
    Sam4sBT: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptBT(fiscalReceipt, printSlip, sam4sSaleMachine, deviceParams, sendMessageToWebView)
    },
    Sam4sSerial: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptSerial(fiscalReceipt, printSlip, sam4sSaleMachine, deviceParams, sendMessageToWebView)
    }
  },
  payIn: {
    Sam4sQR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInQR(reason, amount, type, sam4sPayIn, deviceParams, sendMessageToWebView, info)
    },
    Sam4sBT: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInBT(reason, amount, type, sam4sPayInMachine, deviceParams, sendMessageToWebView, info)
    },
    Sam4sSerial: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payInSerial(reason, amount, type, sam4sPayInMachine, deviceParams, sendMessageToWebView, info)
    }
  },
  payOut: {
    Sam4sQR: async (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutQR(reason, amount, type, sam4sPayOut, deviceParams, sendMessageToWebView, info )
    },
    Sam4sBT: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutBT(reason, amount, type, sam4sPayOutMachine, deviceParams, sendMessageToWebView, info)
    },
    Sam4sSerial: async  (reason, amount, type, deviceParams, sendMessageToWebView, info) => {
      return await payOutSerial(reason, amount, type, sam4sPayOutMachine, deviceParams, sendMessageToWebView, info)
    }
  }
}

export {
  sam4sDriver
}